import { render, staticRenderFns } from "./Outgoing-mail.vue?vue&type=template&id=262cf9d6&"
import script from "./Outgoing-mail.vue?vue&type=script&lang=js&"
export * from "./Outgoing-mail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports